<template>
  <layout class="bg-gradient-light">
    <content-scroll-container class="h-full">
      <content-scroll-inner class="flex flex-col h-full">
        <box-title-l :lines="1">
          App Update
        </box-title-l>
        <top-sub-b>
          <p class="text-chplus-regular text-landingfade-dark m-auto">
            All good things must come to an end<br />
            It is time for you to update the app
          </p>
        </top-sub-b>
        <box-logo-l />
        <div class="flex-grow flex flex-col">
          <p>
            Unfortunately, our service cannot support this version of the app
            anymore. If you want to continue using the app, please consider
            updating by clicking on the button below.
          </p>
        </div>
        <button
          type="button"
          class="flex-shrink-0 p-3 w-full my-1 rounded-lg text-white bg-gradient-blue"
          @click="onClick"
        >
          Update the app
        </button>
      </content-scroll-inner>
    </content-scroll-container>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/LayoutBase";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import BoxTitleL from "@/components/layouts/BoxTitleL";
import TopSubB from "@/components/layouts/TopSubB";
import BoxLogoL from "@/components/layouts/BoxLogoL";

export default {
  name: "UpdateApp",
  components: {
    ContentScrollContainer,
    ContentScrollInner,
    Layout,
    BoxTitleL,
    TopSubB,
    BoxLogoL
  },
  methods: {
    onClick() {
      const storeUrl =
        process.env.VUE_APP_PLATFORM === "ios"
          ? "itms-apps://itunes.apple.com/app/com.ommon.votingapp"
          : "market://details?id=com.ommon.votingapp";
      cordova.InAppBrowser.open(storeUrl, "_system");
    }
  }
};
</script>
